import { ImgProps } from '../components/ProductWorkbenchCanvas/types';

function flipLayer(draggable: ImgProps[]) {
    let newLayers = {};
    draggable.map((layer) => {
        layer.scaleX = -layer.scaleX;
        // @ts-ignore
        // layer.offsetX =
        //     layer.offsetX === 0
        //         ? // @ts-ignore
        //           layer.width < layer.maxWidth
        //             ? layer.width
        //             : // @ts-ignore
        //               layer.maxWidth
        //         : 0;
        // @ts-ignore
        newLayers[layer.id] = layer;
    });
    return newLayers;
}

export default flipLayer;
